"use client";

import { CONSENT_COOKIE_NAME, type ConsentStateT } from "@/app/types/consent";

export function getConsentClient(): ConsentStateT | null {
  if (typeof document === "undefined") return null;

  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${CONSENT_COOKIE_NAME}=`))
    ?.split("=")[1];

  if (!cookieValue) return null;

  try {
    const parsed = JSON.parse(decodeURIComponent(cookieValue)) as ConsentStateT;
    if (typeof parsed?.version !== "number" || !parsed?.preferences)
      return null;

    // Force necessary to true always
    parsed.preferences.necessary = true;
    return parsed;
  } catch {
    return null;
  }
}
